<div class="flex-container" style="flex-direction: column" [hidden]="hidden">
  <div class="column">
    <app-textbox
      [label]="'Recipient name'"
      [required]="true"
      [(ngModel)]="shippingAddress.recipientLine1"
      (onChanged)="handleRecipientNameUpdated($event)"
    />
  </div>

  <div class="width-constrained-some">
    <app-street-address
      [enableEditing]="true"
      [addressLabel]="''"
      [(ngModel)]="shippingAddress"
      (addressUpdated)="handleShippingAddressUpdated($event)"
    ></app-street-address>
  </div>
</div>
